import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import ruRU from 'antd/locale/ru_RU'
import App from './App'
import './index.css'

// * Error boundary component
class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; error: Error | null }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('React Error Boundary caught error:', error, errorInfo)
    
    // ! Try to clear corrupted localStorage
    try {
      localStorage.removeItem('afi-auth-storage')
      localStorage.removeItem('parsing-state-storage')
      console.log('Cleared potentially corrupted localStorage')
    } catch (e) {
      console.error('Failed to clear localStorage:', e)
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '20px', 
          maxWidth: '800px', 
          margin: '50px auto',
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <h1 style={{ color: '#ff4d4f' }}>Ошибка приложения</h1>
          <p>Произошла ошибка при загрузке приложения.</p>
          <p><strong>Сообщение ошибки:</strong> {this.state.error?.message}</p>
          <p><strong>Stack trace:</strong></p>
          <pre style={{ 
            backgroundColor: '#f5f5f5', 
            padding: '10px', 
            borderRadius: '4px',
            overflow: 'auto',
            fontSize: '12px'
          }}>
            {this.state.error?.stack}
          </pre>
          <button
            onClick={() => {
              // ! Clear all storage and reload
              localStorage.clear()
              sessionStorage.clear()
              window.location.reload()
            }}
            style={{
              padding: '10px 20px',
              backgroundColor: '#1890ff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              marginTop: '20px'
            }}
          >
            Очистить кэш и перезагрузить
          </button>
        </div>
      )
    }

    return this.props.children
  }
}

// ! Try to catch localStorage errors early
try {
  const authStorage = localStorage.getItem('afi-auth-storage')
  const parsingStorage = localStorage.getItem('parsing-state-storage')
  
  if (authStorage) {
    JSON.parse(authStorage) // * Validate JSON
  }
  if (parsingStorage) {
    JSON.parse(parsingStorage) // * Validate JSON
  }
} catch (error) {
  console.error('Corrupted localStorage detected, clearing...', error)
  localStorage.removeItem('afi-auth-storage')
  localStorage.removeItem('parsing-state-storage')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ConfigProvider 
        locale={ruRU}
        theme={{
          token: {
            colorPrimary: '#1890ff',
            borderRadius: 6,
          },
        }}
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ConfigProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)

